var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03906 0.1875L2.95312 2.25H0.5625C0.234375 2.25 0 2.50781 0 2.8125V6.1875C0 6.51562 0.234375 6.75 0.5625 6.75H2.95312L5.03906 8.83594C5.39062 9.1875 6 8.95312 6 8.4375V0.585938C6 0.0703125 5.39062 -0.164062 5.03906 0.1875ZM11.25 4.5C11.25 3.02344 10.4766 1.66406 9.23438 0.84375C8.97656 0.679688 8.625 0.75 8.46094 1.03125C8.29688 1.28906 8.36719 1.64062 8.625 1.80469C9.5625 2.39062 10.125 3.42188 10.125 4.5C10.125 5.60156 9.5625 6.63281 8.625 7.21875C8.36719 7.38281 8.29688 7.73438 8.46094 7.99219C8.60156 8.25 8.95312 8.34375 9.23438 8.17969C10.4766 7.35938 11.25 6 11.25 4.5ZM7.92188 2.71875C7.64062 2.55469 7.3125 2.64844 7.14844 2.92969C7.00781 3.21094 7.10156 3.53906 7.38281 3.70312C7.66406 3.86719 7.875 4.17188 7.875 4.5C7.875 4.85156 7.66406 5.15625 7.38281 5.32031C7.10156 5.48438 7.00781 5.8125 7.14844 6.09375C7.3125 6.375 7.64062 6.46875 7.92188 6.30469C8.57812 5.95312 9 5.25 9 4.5C9 3.77344 8.57812 3.07031 7.92188 2.71875Z",
    fill: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.8f584b69.svg";
export { ForwardRef as ReactComponent };